import Bloodhound from "typeahead.js/dist/bloodhound";

const originalSearch = Bloodhound.prototype.search;
Bloodhound.prototype.search = function(query, sync, async) {
    // Store last query in the instance
    this.lastQuery = query;
    return originalSearch.call(this, query, sync, async);
};

export { Bloodhound };
